/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, createRef } from "react";
import { connect } from "react-redux";
import { Select, Button, Spin, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from "axios";
import dot from 'dot-object';
import deepmerge from 'deepmerge';
import _ from 'lodash';
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { getInputProp } from "../helper";
import { filterSelectOptions } from 'datastake-daf/src/helpers/Forms';
import { propHasValue } from "../../../components/DynamicFormNew/helper";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getPopupContainer } from "../../../helpers/popUp";
import { getMetaPlaceholer } from "../../../helpers/form";
import { useGeneralContext } from "../../../context/General";
import { getApiBaseUrl, getAppHeader } from "../../../services/BaseService";

const toRemoveKeysOnNew = ['datastakeId', 'id', '_id', 'parent'];

const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

function AjaxSelect({
  preSelected,
  authentication: { user },
  props = {},
  size = "large",
  formsValue = {},
  call = '',
  value = null,
  repeatIndex = null,
  changeInputMeta = () => { },
  repeatValues = null,
  mainForm,
  onNewSetValue = null,
  inputMeta = {},
  multiple = false,
  setFormValues = () => { },
  updateOptions = false,
  unique = null,
  meta = {},
  name = null,
  inputName = null,
  getFromLinking = false,
  allowClear = false,
  onChange = () => { },
  onOptions = () => { }
}) {
  const { t } = useTranslation();
  const inst = createRef();
  const [modelValue, setModelValue] = useState(value ? value : (multiple ? [] : null));
  const [model, setModel] = useState([]);
  const [latestValue, setLatestValue] = useState(null);
  const [entity, method, mapper, updateOtherValues] = call.replace('\\"', '"').replace('\n', '').split('::');
  const filters = method.split(/\(/).length > 1
    ? JSON.parse(method.split(/\(/)[1].split(/\)/)[0]) : '';
  const [isFetching, setIsFetching] = useState(false);
  const [searchValue, setSearchValue] = useState(inputMeta?.name || value);
  const [lastFilters, setLastFilters] = useState({});
  const [isFetchWithThisFilter, setIsFetchWithThisFilter] = useState(false);
  const { changeAjaxOptions } = useGeneralContext();
  const url = getApiBaseUrl();

  const endpoint = meta.application ?
    `${url}/query/${meta.application}/options`
    : `${url}/query/options`

  useEffect(() => {
    if (value === 'new') {
      if (!model.find(m => m.value === 'new')) {
        setModel(model.concat({ label: searchValue || t('New'), value: 'new' }))
        if (updateOptions) {
          onOptions(model.concat({ label: searchValue || t('New'), value: 'new' }));
        }
      }
    } else {
      setModel(model.filter((v) => v.value !== 'new'));
    }
    setModelValue(value ? value : (multiple ? [] : null));
    setSearchValue(value);
    // updateLabel(model, value);
  }, [value]);

  const addNewValueKey = (val) => {
    if (meta?.onNewSetValueKey && val) {
      mainForm.setFieldValue(meta.onNewSetValueKey, val);
      changeInputMeta({
        key: name,
        type: 'text',
        value: { name: val },
        otherValues: { [meta.onNewSetValueKey]: val },
      })
    }
  }

  useEffect(() => {
    if (getFromLinking) {
      if (entity === 'Stakeholder') {
        setModel(Object.values(formsValue?.linking?.STAKEHOLDER || {}).map((v) => ({
          value: v.id,
          label: v.name,
        })))
      }

      if (entity === 'LocationService') {
        setModel(Object.values(formsValue?.linking?.SCL || {})
          .filter((v) => v.level !== "level_1" && v.level !== "level_2")
          .map((v) => ({
            value: v.id,
            label: v.locationName,
          })))
      }
    } else {
      const filterValues = pickFilterValue();
      if ((Object.keys(filters).length
        && Object.keys(formsValue).length
        && hasChangedDependent() && searchValue) || (searchValue && !isFetchWithThisFilter) || !_.isEqual(filterValues, lastFilters)) {
        setIsFetching(true);
        setLastFilters(filterValues);
        axios.post(endpoint, {
          entity,
          method: typeof filterValues === 'object'
            ? method.split(/\(/)[0]
            : method,
          mapper: JSON.parse(mapper),
          filters: { ...filterValues, preSelected },
        }, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            ...getAppHeader(),
          },
        }).then(({ data }) => {
          if (meta.saveAjaxOptions) {
            changeAjaxOptions(name, data);
          }

          if (modelValue === 'new') {
            const newData = model.find(m => m.value === 'new');
            data = data.concat([newData || { label: inputMeta?.name || searchValue || t('New'), value: 'new' }]);
          } else {
            updateLabel(data, undefined, true);
            setTimeout(() => {
              updateLabel(data, modelValue, true);
            }, 100)
          }
          setModel(data);
          if (updateOptions) {
            const oldModelValue = modelValue;
            onOptions(data);
            setTimeout(() => {
              setModelValue(oldModelValue);
              onChange(oldModelValue, data || []);
            }, 10);
          }
          if (multiple) {
            if (Array.isArray(modelValue) && modelValue.length > 0) {
              const option = data.find(o => modelValue.includes(o.value));
              if (!option) {
                setModelValue([]);
                setSearchValue(null);
                onChange([], data || []);
              }
            }
          } else {
            const option = data.find(o => o.value === modelValue);
            if (!option && modelValue) {
              setModelValue(null);
              setSearchValue(null);
              onChange(undefined, data || []);
            }
          }
          setIsFetching(false);
          setIsFetchWithThisFilter(true);
        }).catch((e) => {
          console.log(e);
          setIsFetching(false);
        });
      }

    }
  }, [formsValue, repeatValues, searchValue]);

  const pickFilterValue = () => {
    if (mainForm && typeof mainForm.getFieldsValue === 'function') {
      formsValue = deepmerge(formsValue || {}, mainForm.getFieldsValue() || {}, { arrayMerge: overwriteMerge });
      if (propHasValue(repeatIndex)) {
        const formList = mainForm.getFieldsValue(name);
        if (formList && formList[repeatIndex]) {
          repeatValues = formList[repeatIndex];
        }
      }
    }
    setLatestValue(formsValue);
    return Object.keys(filters).reduce((f, a) => {
      if (filters[a].split('/').length > 1) {
        const filter = filters[a].split('/')[1];
        const [objField, transform] = filter.split(/( as )/gmi);
        if (transform && transform.trim() !== '') {
          f[a] = objField
        } else if (dot.pick(objField, repeatValues)) {
          f[a] = dot.pick(objField, repeatValues);
        }
      } else {
        const [objField, transform] = filters[a].split(/( as )/gmi);
        if (transform && transform.trim() !== '') {
          f[a] = objField
        } else if (dot.pick(objField, formsValue)) {
          f[a] = dot.pick(objField, formsValue);
        } else if (dot.pick(objField, repeatValues)) {
          f[a] = dot.pick(objField, repeatValues);
        }
      }
      return f;
    }, {});
  }

  const updateLabel = (data, val, noSave = false) => {
    if (!noSave) {
      const selectedValue = data.find(d => d.value === val);
      if (selectedValue && onNewSetValue) {
        if (repeatIndex !== null && repeatValues) {
          repeatValues[onNewSetValue] = selectedValue.label;
          if (!formsValue[name]) {
            formsValue[name] = [];
          }
          formsValue[name][repeatIndex] = repeatValues;
          mainForm.setFieldsValue({ [name]: formsValue[name] });
          mainForm.scrollToField([name, repeatIndex, onNewSetValue]);
        } else {
          mainForm.setFieldsValue({ [onNewSetValue]: selectedValue.label });
          mainForm.scrollToField(onNewSetValue);
        }
      } else if (selectedValue) {
        const _new = { [name]: val };
        mainForm.setFieldValue(name, val);

        if (meta?.onNewSetValueKey) {
          mainForm.setFieldValue(meta.onNewSetValueKey, selectedValue.label);
          _new[meta.onNewSetValueKey] = selectedValue.label;
        }

        changeInputMeta({
          key: name,
          type: 'text',
          value: {},
          otherValues: _new,
        })
      }
    }
  }

  const hasChangedDependent = () => {
    if (mainForm && typeof mainForm.getFieldsValue === 'function') {
      formsValue = deepmerge(formsValue || {}, mainForm.getFieldsValue() || {}, { arrayMerge: overwriteMerge });
    }
    return Object.keys(filters).map(a => {
      if (dot.pick(filters[a], formsValue)) {
        return dot.pick(filters[a], formsValue) === dot.pick(filters[a], latestValue);
      } else if (dot.pick(filters[a], repeatValues)) {
        return dot.pick[filters[a], repeatValues] === dot.pick(filters[a], latestValue);
      }
      return null;
    }).includes(false);
  };

  const getNotFoundContent = (asOption = false) => {
    if (!isFetchWithThisFilter && !searchValue) {
      return <span>{t('Type to search')}</span>;
    } else if (isFetching) {
      return <Spin size="small" />;
    }

    if (meta?.noAddNew) {
      return null;
    }

    return <Button
      style={{ width: 'calc(100% - 16px)', margin: '0 8px' }}
      icon={<PlusOutlined style={{ marginTop: 4 }} />}
      disabled={
        !searchValue ||
        (typeof searchValue === 'string' && searchValue.trim() === '') ||
        (
          (
            (typeof modelValue === 'string' && modelValue !== 'new') ||
            (modelValue === 'new' && (model.filter(m => m.value === 'new' && m.label === searchValue)))
          ) && asOption
        )
      }
      type="link primary"
      onClick={() => {
        const oldValue = searchValue;
        addNewData(oldValue);
      }}>{i18next.t('Confirm new subject')}</Button>
  }

  function updateOther(item, label, value) {
    try {
      const updateOtherVal = JSON.parse(updateOtherValues);
      const _new = { ...formsValue };
      if (updateOtherVal && Array.isArray(updateOtherVal) && updateOtherVal.length) {
        updateOtherVal.forEach(key => {
          if (repeatIndex !== null && repeatValues) {
            repeatValues[key] = item[key];
            if (!formsValue[name]) {
              formsValue[name] = [];
            }
            formsValue[name][repeatIndex] = repeatValues;
            mainForm.setFieldsValue({ [name]: formsValue[name] });
          } else {
            _new[key] = item[key]
            mainForm.setFieldsValue({ [key]: item[key] });
          }
        })
      }

      if (meta?.onNewSetValueKey) {
        mainForm.setFieldValue(meta.onNewSetValueKey, label);
        _new[meta.onNewSetValueKey] = label
      }

      _new[name] = value;
      mainForm.setFieldValue(name, value);

      changeInputMeta({
        key: name,
        type: 'text',
        value: {},
        otherValues: _new,
      })
      setFormValues(_new);
    } catch {

    }

  }

  let notFoundContent = {
    notFoundContent: getNotFoundContent(),
  };

  if (onNewSetValue === false) {
    notFoundContent = {};
  }

  const validateSelection = (value, item, setValue = false) => {
    if (item && (item.users || formsValue.preSelected)) {
      const isSelected = formsValue && formsValue.preSelected && Array.isArray(formsValue.preSelected) && formsValue.preSelected.includes(value) ? true : false;
      const isIdentified = unique && item.users && item.users.includes(user?.company?.id) ? true : false;
      if (isIdentified && !isSelected) {
        message.error(unique);
        inst.current.focus();
      } else if (isSelected) {
        message.error(t('You have already provided this information for this question.'));
        inst.current.focus();
      } else {
        onChange(value, model || [])
        updateLabel(model, value);

        updateOther(item, model.find((v) => v.value === value)?.label);
        if (setValue) {
          setModelValue(value);
        }
      }
    } else {
      // onChange(value, model || [])
      // addNewValueKey(model.find((v) => v.value === value)?.label);
      updateLabel(model, value);
      updateOther(item, model.find((v) => v.value === value)?.label, value);
      if (setValue) {
        setModelValue(value);
      }
    }
    if (!value) {
      setModel([
        ...(model || []).filter(m => m.value !== 'new')
      ])
    }
  }

  const addNewData = (oldValue) => {
    if (onNewSetValue) {
      if (repeatIndex !== null && repeatValues) {
        repeatValues[inputName] = 'new';
        repeatValues[onNewSetValue] = oldValue;
        if (!formsValue[name]) {
          formsValue[name] = [];
        }
        formsValue[name][repeatIndex] = repeatValues;
        // mainForm.setFieldsValue({ [name]: formsValue[name] });
        // mainForm.scrollToField([name, repeatIndex, onNewSetValue]);
      } else {
        // mainForm.setFieldsValue({ [onNewSetValue]: oldValue });
        // mainForm.scrollToField(onNewSetValue);
      }
    }
    const newModelInd = model.findIndex(m => m.value === 'new');
    let newModel = { label: oldValue, value: 'new' };
    if (newModelInd >= 0) {
      model[newModelInd] = newModel;
    } else {
      model.push(newModel);
    }

    setModel([...model]);
    if (updateOptions) {
      onOptions(model.concat({ label: oldValue || t('New'), value: 'new' }));
    }
    setModelValue('new');
    inst.current.blur();
    if (!onNewSetValue) {
      const otherValues = onNewSetValue ? {
        [onNewSetValue]: searchValue,
        [name]: 'new',
      } : { [name]: 'new' };

      // remove keys, because can be from prev selection
      toRemoveKeysOnNew.forEach((k) => {
        if (formsValue[k]) {
          otherValues[k] = undefined;
        }
      });

      if (meta?.onNewSetValueKey) {
        otherValues[meta?.onNewSetValueKey] = searchValue;
      }

      changeInputMeta({
        key: name,
        type: 'text',
        value: { name: searchValue },
        otherValues,
      })
      return;
    }

    setTimeout(() => {
      onChange('new', model || []);
      addNewValueKey(searchValue, true);
    }, 200);
  }

  return (
    <Select
      autoComplete="new-password"
      {...getPopupContainer()}
      size={size}
      allowClear={allowClear}
      ref={inst}
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || getInputProp(props.placeholder, formsValue) || i18next.t('Select one option')}
      showSearch
      value={modelValue}
      {...multiple ? { mode: "multiple" } : {}}
      filterOption={filterSelectOptions}
      optionFilterProp="label"
      options={model || []}
      dropdownRender={(origin) => {
        const opts = model.map((m) => ({ children: m.label || '' }));
        const filtered = opts.filter((v) => filterSelectOptions(searchValue || '', v))

        return <div>
          {origin}
          {onNewSetValue !== false &&
            searchValue &&
            filtered.length &&
            !isFetching ? getNotFoundContent(true) : null}
        </div>;
      }}
      onKeyDown={(ev) => {
        if ([9, 13].includes(ev.keyCode) && onNewSetValue) {
          const value = ev.target.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          const option = model.find(o => {
            const stringOption = o && o.label ? o.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "") : '';
            return o.label && stringOption.indexOf(value) === 0;
          });
          if (option) {
            validateSelection(option.value, option, true);
          } else {
            addNewData(ev.target.value);
          }
        }
      }}
      onChange={(ev, item) => {
        validateSelection(ev, item, true)
      }}
      onSearch={searchValue => {
        if (!searchValue) {
          setSearchValue(null);
        } else {
          setSearchValue(searchValue);
        }
      }}
      {...notFoundContent}
    />
  )
}

const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(AjaxSelect);
